var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewPatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New",
    clipPath: "url(#clip0_1232_24358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add_circle_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 1C11.8661 1 15 4.1339 15 8C15 11.8661 11.8661 15 8 15C4.1339 15 1 11.8661 1 8C1 4.1339 4.1339 1 8 1ZM8 4.5C7.82855 4.50002 7.66306 4.56297 7.53494 4.6769C7.40681 4.79083 7.32496 4.94782 7.3049 5.1181L7.3 5.2V7.3H5.2C5.02158 7.3002 4.84998 7.36852 4.72024 7.49099C4.59051 7.61347 4.51244 7.78087 4.50198 7.95898C4.49152 8.13709 4.54947 8.31247 4.66399 8.44928C4.7785 8.5861 4.94093 8.67403 5.1181 8.6951L5.2 8.7H7.3V10.8C7.3002 10.9784 7.36852 11.15 7.49099 11.2798C7.61347 11.4095 7.78087 11.4876 7.95898 11.498C8.13709 11.5085 8.31247 11.4505 8.44928 11.336C8.5861 11.2215 8.67403 11.0591 8.6951 10.8819L8.7 10.8V8.7H10.8C10.9784 8.6998 11.15 8.63148 11.2798 8.50901C11.4095 8.38653 11.4876 8.21913 11.498 8.04102C11.5085 7.86291 11.4505 7.68753 11.336 7.55072C11.2215 7.4139 11.0591 7.32597 10.8819 7.3049L10.8 7.3H8.7V5.2C8.7 5.01435 8.62625 4.8363 8.49497 4.70503C8.3637 4.57375 8.18565 4.5 8 4.5Z",
    fill: "#82DED9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1232_24358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPatient);
export default __webpack_public_path__ + "static/media/new-patient.4d9e9924f2b815e16452e565a7d8d62b.svg";
export { ForwardRef as ReactComponent };